<template>
  <div class="products-wrapper">
    <img class="products-grid__banner" src="/images/product_list_banner.jpg" alt="dekoeko winter banneer"/>
    <v-overlay :value="loaders.loadingProducts" absolute opacity="0.1">
      <v-progress-circular indeterminate color="primary" size="128"></v-progress-circular>
    </v-overlay>
    <v-row class="pl-5 pr-5">
      <v-col
          cols="12"
          lg="1"
          md="1"
          class="order-md-last mt-3 d-lg-none"
          @click="layout.showDrawer = !layout.showDrawer"
      >
        <span class="btn-categories-filters">
           {{ $t('searchableProducts.products.filters_and_categories') }}
        </span>
      </v-col>
      <v-col cols="12">
        <v-row v-if="this.params.search">
          <v-col cols="12" class="justify-center">
            <h1>
              {{ $t('searchableProducts.products.you_are_searching') }}
              „{{ this.params.search }}”
            </h1>
          </v-col>
        </v-row>
        <div>
          <h1 class="products-wrapper__headline">
              <span v-if="params.categories.length > 0">
                {{ params.categories[params.categories.length - 1].name }}
              </span>
          </h1>
        </div>
      </v-col>

    </v-row>
    <v-row class="pl-5 pr-5" v-if="loadedChristmasBanner">
      <v-col cols="12">
        <v-img src="/images/christmas-banner.jpg"/>
      </v-col>
    </v-row>
    <v-row class="products-grid products-grid--quote" v-if="!this.loaders.loadingProducts && products.data && quotesProducts.data && quotesProducts.data.length > 0">
      <v-col cols="12" class="pb-0">
        <h2 class="products-grid__sub-headline">
          {{ $t('searchableProducts.products.from_your_waste') }}
        </h2>
      </v-col>
      <div class="products-grid-slider">
        <div class="products-grid-slider__slide"
             v-for="product in quotesProducts.data"
             :key="product.id"
        >
          <ProductCard
              :product="product"
          />
        </div>
      </div>
      <div class="products-grid-slider-buttons">
        <button class="slider-button slider-button--prev product-grid-slider-prev"></button>
        <button class="slider-button slider-button--next product-grid-slider-next"></button>
      </div>

    </v-row>
    <v-row class="products-grid" id="main-products-grid">
      <v-col cols="12" class="pb-0">
        <h2 class="products-grid__sub-headline" v-show="!this.loaders.loadingProducts && products.data && products.data.length > 0">
          {{ $t('searchableProducts.products.ready_products') }}
        </h2>
      </v-col>
      <v-col cols="12" class="header-info"
             v-show="!this.loaders.loadingProducts && products.data && products.data.length < 1">
        {{ $t('searchableProducts.products.no_results') }}
        <a href="/products">
          {{ $t('searchableProducts.products.see_all') }}
        </a>
      </v-col>
      <v-col
          v-for="product in products.data"
          :key="product.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="3"
      >
        <ProductCard
            :product="product"
        />
      </v-col>

      <v-col cols="12" class="products-grid__pagination">
        <v-pagination
            v-if="totalPages > 1"
            v-model="page"
            :length="totalPages"
            :page="page"
            prev-icon="products-grid__pagination-prev"
            next-icon="products-grid__pagination-next"
            total-visible="7"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../../../api/index';
import ProductCard from "./ProductCard";

export default {
  components: {ProductCard},
  props: ['params', 'layout', 'loaders'],
  data: () => ({
    products: [],
    quotesProducts: [],
    page: 1,
    perPage: 12,
    paginationFromUrl: false,
    sortBy: '',
    paginationOptions: [12, 24, 36, 48],
    sortByOptions: ['name', 'price'], // disabled sort by designer (required translations from backend: sorter)
  }),
  created() {
    if (!new URLSearchParams(location.search).get('categories') &&
        !new URLSearchParams(location.search).get('material')) {
      this.fetchProducts();
    }
    this.getPriceFromUrl();
  },
  computed: {
    taxonIds() {
      let categoryIds = this.params.categories;

      if (categoryIds.length > 0) {
        categoryIds = categoryIds[this.params.categories.length - 1].id;
      }

      const brandIds = this.params.brands.map(brand => {
        return brand.id;
      });
      return [].concat(brandIds, categoryIds);
    },
    materialIds() {
      return this.params.materials.map(material => {
        return material.id;
      });
    },
    price() {
      return `${this.params.priceRange[0]},${this.params.priceRange[1]}`;
    },
    totalPages() {
      if (this.products.meta) {
        return this.products.meta.total_pages;
      }

      return 0;
    },
    christmasCategory() {
      if (this.params.categories.length > 0) {
        return this.params.categories[0].name === 'Christmas';
      }

      return false;
    },
    loadedChristmasBanner() {
      return this.christmasCategory && !this.loaders.loadingProducts;
    }
  },
  methods: {
    fetchProducts: _.debounce(function () {
      this.loaders.loadingProducts = true;
      this.fetchQuoteProducts();
      api.get(
          `/api/v2/storefront/products?search=${this.params.search}&filter[show_discontinued]&per_page=${this.perPage}&page=${this.page}&filter[taxons]=${this.taxonIds}&filter[materials]=${this.materialIds}&filter[price]=${this.price}&sort=${this.sortBy}&filters=save`,
      ).then(res => {
        const {data} = res;
        this.products = data;
        //remove products without attributes
        if (this.products.data) {
          this.products.data = this.products.data.filter(product => product.attributes)
        }
        this.loaders.loadingProducts = false;
        this.scrollToTopProductsList();
      });
    }, 200),

    fetchQuoteProducts: _.debounce(function () {
      api.get(
          `/api/v2/storefront/products?search=${this.params.search}&filter[show_discontinued]&per_page=8&page=1&filter[only_quote]=1&filter[taxons]=${this.taxonIds}&filter[price]=${this.price}&filters=save`,
      ).then(res => {
        const {data} = res;
        this.quotesProducts = data;
        //remove products without attributes
        if (this.quotesProducts.data) {
          this.quotesProducts.data = this.quotesProducts.data.filter(product => product.attributes)
        }
      });
    }, 200),

    removeFilter(filter, collection) {
      this.$delete(collection, collection.indexOf(filter));
    },

    getPriceFromUrl() {
      const searchParams = new URLSearchParams(location.search);
      const priceFrom = searchParams.get('price_from');
      const priceTo = searchParams.get('price_to');
      if (!this.priceFromUrl) {
        if (priceFrom) {
          this.params.priceRange[0] = parseInt(priceFrom);
        }
        if (priceTo) {
          this.params.priceRange[1] = parseInt(priceTo);
        }
      }
      this.priceFromUrl = true;
    },
    generateBreadcrumbs(categories) {
      const crumbtrail = document.querySelector('.crumbtrail');
      const jsGeneratedBreadcrumbs = crumbtrail.querySelectorAll('.js-generated');
      jsGeneratedBreadcrumbs.forEach((el) => {
        el.remove();
      })

      for (const category of categories) {
        const breadcrumb = document.createElement('a');
        breadcrumb.classList.add('dark', 'js-generated');
        breadcrumb.innerText = category.name;
        breadcrumb.setAttribute('href', `?categories=${category.permalink}`);
        crumbtrail.append(breadcrumb);
      }

    },
    scrollToTopProductsList() {
      window.scrollTo({top: 0, behavior: "smooth"});
    },
  },
  watch: {
    'page'() {
      this.fetchProducts();
    },
    'perPage'(perPage) {
      if (!this.paginationFromUrl) {
        this.fetchProducts();
        this.page = 1;
        this.addPaginationToUrl(perPage);
      }
    },
    'sortBy': {
      handler: function (val, oldVal) {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', val);
        history.pushState(null, '', url.toString().replaceAll('%2F', '/'));
      }
    },
    'params': {
      handler: function () {
        this.fetchProducts();
      },
      deep: true,
    },
    'params.categories': {
      handler: function (categories) {
        this.generateBreadcrumbs(categories);
        if (categories.length > 0) {
          const url = new URL(location.href);
          url.searchParams.set('categories', categories[categories.length - 1].permalink);
          history.pushState(null, '', url.toString().replaceAll('%2F', '/'));
        }
      }
    },
    'quotesProducts': {
      handler: () => {
        setTimeout( () => {
          $('.products-grid-slider').slick({
            speed: 300,
            slidesToShow: 4,
            initialSlide: 0,
            centerMode: false,
            variableWidth: false,
            dots: false,
            slidesToScroll: 1,
            prevArrow: $('.product-grid-slider-prev'),
            nextArrow: $('.product-grid-slider-next'),
            responsive: [
              {
                breakpoint: 1264,
                settings: {
                  slidesToShow: 3,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          }).slick('setPosition');
        }, 660);
      }
    }
  },
};
</script>

<style lang="scss">
.strikethrough {
  text-decoration: line-through;
}

.products-wrapper {
  min-height: 200vh;

  &__headline {
    font-size: 24px;
    color: #e81574;
    text-transform: uppercase;
    margin-bottom: 14px;

    @media (max-width: 992px) {
      margin-bottom: 0;
    }

    span:before {
      content: '/';
    }

    span:first-child:before {
      content: '';
    }
  }
}

.no-decoration:hover {
  text-decoration: none;
  color: #E60F73 !important;
}

.one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.products-grid {
  padding-right: 124px;
  padding-left: 20px;

  &--quote {
    margin-bottom: 60px;
    @media (max-width: 600px) {
      margin-bottom: 32px;
    }
  };

  @media(max-width: 1500px) {
    padding-right: 42px;
  }

  @media(max-width: 762px) {
    padding-right: 20px;
  }

  .v-card.v-card--flat {
    height: 100%;
  }

  .theme--light.v-card.v-card--outlined.v-card--only-quote {
    border-color: #e80f71;
  }

  .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 0;
  }

  .v-image{
    height: 240px;
    max-height: 240px;
    position: relative;

    @media (max-width: 1800px) {
      height: 248px;
    }
  }

  .v-card__title {
    padding: 8px 0;
  }

  &__sub-headline {
    font-size: 25px;
    color: #e81574;
    font-weight: normal;
  }

  & &__see-more.v-btn {
    position: absolute !important;
    height: 50px !important;
    width: 242px;
    background-color: #e85181 !important;
    border-radius: 4px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 18px;
    top: -25px;
    left: 55px;

    &:hover {
      text-decoration: none !important;
    }
  }

  &__vendor-name {
    font-size: 12px;
    font-weight: 300;
    color: #707070;
    opacity: 0.7;
    margin-left: 10px;
  }

  &__name {
    margin-top: 5px;
    color: #707070;
    font-weight: bold;
    text-align: center;
    width: 100%;
    display: block;
    font-size: 14px;
    padding: 0 10px;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  &__info-container {
    margin-top: auto;
  }

  &__banner {
    height: auto;
    width: 100%;
    padding-left: 20px;
    max-width: 1132px;
    margin-top: 28px;
    margin-bottom: 40px;

    @media (max-width: 1850px) {
      padding-right: 40px;
    }
  }

  & &__price-container {
    display: flex;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    color: #707070;
    padding-bottom: 5px;

    &--wholesale {
      width: 100%;
      padding-right: 16px;
      margin-bottom: 15px;
    }
  }

  &__retail-price {
    font-size: 20px;
    color: #e80f71;
    margin-right: 10px;
    font-weight: bold;
    position: relative;
    top: -2px;

    @media(max-width: 1800px) {
      font-size: 16px;
    }

    &--disabled {
      color: #707070;
    }
  }
  &__see-wholesale-price {
    font-size: 16px;
    color: #e85181;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    display: inline-block;
    width: 100%;
    margin-bottom: 12px;

    &:hover {
      text-decoration: none;
    }
  }

  .retail-price-desc {
    width: 70px;
    line-height: 1.2;
    position: relative;
    top: -3px;
    font-size: 10px;
  }

  .wholesale-price-desc {
    line-height: 1;
    margin: auto 0 4px;
  }

  &__pagination {
    margin-top: 76px;
    margin-bottom: 191px;
    padding: 0 !important;

    .v-pagination__more {
      margin: 0;
      width: 15px !important;
      height: 30px !important;
    }

    .v-pagination__navigation {
      background-image: url("/images/icons/pagination-arrow.svg") !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-size: 9px 8px !important;
      width: 9px;
    }

    li {
      &:first-child .v-pagination__navigation {
        margin: 0 0 0 9px;
        transform: rotate(180deg);
      }
      &:last-child .v-pagination__navigation {
        margin: 0 9px 0 0;
      }
    }

    .v-pagination__navigation, .v-pagination__item {
      box-shadow: none;
    }

    .v-pagination__item {
      width: 30px !important;
      height: 30px !important;
      min-width: auto !important;
      border-radius: 0;
      margin: 0 7.5px;
      border: 1px solid #707070;
      font-size: 14px;
      color: #707070;
      font-weight: bold;
    }
  }
}

.btn-categories-filters {
  width: 174px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #e81574;
  color: #e81574;
  cursor: pointer;
  text-transform: uppercase;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  padding-top: 3px;
}

.products-grid-slider {
  overflow-x: hidden;
  width: 100%;
  white-space: nowrap;
  padding-bottom: 4px;

  &:not(.slick-initialized) {
    display: inline-flex;
  }

  & .slick-track {
    display: inline-flex;
  }

  &__slide {
    display: inline-block;
    margin: 0 12px;
    height: inherit;

    &:not(.slick-slide) {
      max-width: calc(100%/4 - 24px);
    }
  }
}

.products-grid-slider-buttons {
  position: relative;
  width: 75px;
  margin-top: 15px;
  margin-left: auto;
  margin-right: 10px;

  @media (max-width: 600px) {
    width: 100%;
    margin: 15px 12px;
  }

  .slider-button--prev {
    left: 0;
  }

  .slider-button--next {
    right: 0
  }

  @media (max-width: 600px) {
    .slider-button--next, .slider-button--prev {
      width: 40px;
      height: 40px;
      background-position: 15px;
      background-size: 8px;
    }
  }
}
</style>